import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const VerifyInvalid = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  // 파라미터 또는 경로 세그먼트에서 storeNo 추출
  const segments = location.pathname.split('/').filter(Boolean);
  const getNextOf = key => {
    const idx = segments.indexOf(key);
    return idx !== -1 && segments[idx + 1] ? segments[idx + 1] : null;
  };
  const extractedStoreNo =
    params.storeNo ||
    getNextOf('verification') ||
    getNextOf('verifyconfirm') ||
    getNextOf('verifysuccess') ||
    getNextOf('verifyfailure') ||
    getNextOf('status') ||
    getNextOf('login') ||
    localStorage.getItem('last_storeNo') ||
    '';

  useEffect(() => {
    const loginPath = extractedStoreNo
      ? `/mobile/login/${extractedStoreNo}/normal`
      : `/mobile/login`;
    navigate(loginPath, { replace: true });
  }, [extractedStoreNo, navigate]);

  return <div>유효하지 않은 검증 시도입니다</div>;
};

export default VerifyInvalid;
